<template>
    <Modal
        v-model="showModal"
        :width="modelWidth"
        :mask-closable="false"
        class-name="new-modal"
        @on-cancel="cancel"
    >
        <div class="content">
            <i class="iconfont icon" style="color:#02cad6;" v-if="type == 'info'">&#xe630;</i>
            <i class="iconfont icon" style="color:#48bb9b;" v-if="type == 'success'">&#xe66b;</i>
            <i class="iconfont icon" style="color:#02cad6;" v-if="type == 'warning'">&#xe616;</i>
            <i class="iconfont icon" style="color:#02cad6;" v-if="type == 'confirm'">&#xe6be;</i>
            <p class="message" v-html="messageInfo"></p>
            <p class="description" v-html="description"></p>
        </div>
        <div slot="footer">
            <Button type="primary" v-if="!isConfirm" @click="onOk">{{okBtnText}}</Button>
            <Button type="ghost" v-if="isConfirm" class="confirmBtn cancel" @click="cancel">{{cancelBtnText}}</Button>
            <Button type="primary" v-if="isConfirm" class="confirmBtn" @click="onOk">{{okBtnText}}</Button>
        </div>
    </Modal>
</template>

<script>
import { api } from "../api/register.js"
export default {
    props:{
        modelWidth:{
            type: Number,
            default: 450
        },
        messageInfo: {
            type: String,
            default: ''
        },
        type: {
            type: String,
            default: 'info'
        },
        okBtnText: {
            type: String,
            default: '确定'
        },
        cancelBtnText: {
            type: String,
            default: '取消'
        },
        description: {
            type: String,
            default: null
        },
        isConfirm: {
            type: Boolean,
            default: false
        }
  },
    data() {
        return {
            showModal: false
        }
    },
    methods: {
        show(flag) {
            this.showModal = flag != undefined ? flag : true
            console.log(this.modelWidth)
        },
        cancel(){
            this.showModal = false
        },
        onOk() {
            this.$emit("onOk")
        }
    }
};
</script>

<style lang="less" >
.new-modal {
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
    .content {
        text-align: center;
        padding-top: 20px;
        .icon {
            font-size: 32px;
        }
    }
    
    button {
        background: #02cad6;
        border-color: #02cad6;
        width: 50%;
        margin: 0 auto;
        display: block;
    }
    .cancel {
        background: #fff;
        border-color: #dddee1;
        color: #dddee1;
    }
    .confirmBtn {
        width: 30%;
        display: inline-block;
        margin: 0 10px;
    }
    .message {
        margin-top: 10px;
        color: #000;
        font-size: 18px;
        font-weight: 500
    }
    .description {
        font-size: 13px;
        font-weight: bold;
        margin-top: 13px;
    }
    .ivu-modal-footer {
        border: none;
        padding-bottom: 30px;
        text-align: center;
    }
}
</style>


// WEBPACK FOOTER //
// new-modal.vue?7f4cdca6